import { inject, Service } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { _BaasBurgerprofielContactActionHook } from '@lvflanders/bar-ng-ui';
import { StartschermMailOnsDialog } from '@lvflanders/startscherm-ng-ui';

export const BURGERPROFIEL_CONTACT_ACTION_FORM = 'CONTACT_FORM';

/**
 * Hook implementation that handles the contact form action from burgerprofiel.
 * This hook is registered via provideBarContainer() and will be invoked when
 * the user clicks the contact link in the burgerprofiel widget.
 */
@Service({ autoProvided: false })
export class BurgerprofielStartschermContactFormHook implements _BaasBurgerprofielContactActionHook {
    readonly #dialog = inject(MatDialog);

    readonly code = BURGERPROFIEL_CONTACT_ACTION_FORM;

    execute(): void {
        this.#dialog.open(StartschermMailOnsDialog, {
            width: '650px'
        });
    }
}
